import { Colors, Spacing } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import { TextField } from 'builder/components/TextField'
import { ButtonV2 } from 'builder/components/Button'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Caption = styled.div`
  color: ${Colors.Neutral50};
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${Media.Phone`
    gap: 12px;
  `}
`

export const StyledTextField = styled(TextField)`
  flex: auto;

  ${Media.Phone`
    flex: 1 1 100%;
  `}
`

export const ContentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  ${Media.Phone`
    gap: 12px;
  `}
`

export const BottomContainer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  justify-content: space-between;
  align-items: center;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing.XS};
`

export const MobileBottomContainer = styled(BottomContainer)`
  justify-content: flex-start;
`

export const MobileButtonsContainer = styled(ButtonsContainer)`
  flex: auto;
`

export const MobileButton = styled(ButtonV2)`
  flex: 1 1 50%;
`

export const MobileLinkButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 28px;

  ${Media.Phone`
    padding: 0 8px;
  `}
`
